export function clean_customer_phone(original_customer_phone){
      const clean_customer_phone = removeSpecialCharacteres(original_customer_phone, "", [" ", "-", "_", "#"]);
      let clean_customer_phone_without_57 = clean_customer_phone;
      if (clean_customer_phone.split("")[0]==="5" && clean_customer_phone.split("")[1]==="7") {
        clean_customer_phone_without_57 = clean_customer_phone.slice(2, clean_customer_phone.split("").length);
      }
      return clean_customer_phone_without_57;
  };
    
  export function removeSpecialCharacteres(string, remplaceWith, extraSpecialCharacteresArray){
    const specialCharacteres = [".", ":", ",", ";", ">", "<", "}", "{", "+", "`", "¿", "'", "|", "/", "°", "!", "$", "%", "&", "(", ")", "=", "]", "[", "¨", "¡", "?", "*", "@", "~", "`", "•", "√", "π", "÷", "x", "¶", "∆", "£", "¢", "€", "¥", "^", "©", "®", "™", "✓", "\\"];
    const splitedString = string.split("");
    let comparativeSpecialCharacteres = [];
    if (extraSpecialCharacteresArray !== undefined && extraSpecialCharacteresArray !== null && extraSpecialCharacteresArray !== "" && extraSpecialCharacteresArray.length > 0) {
      comparativeSpecialCharacteres = [...specialCharacteres, ...extraSpecialCharacteresArray];
    } else {
      comparativeSpecialCharacteres = [...specialCharacteres];
    }
    const cleanStringArray = [];
    splitedString.map((character, index)=>{
      const existSpecialCharacter = comparativeSpecialCharacteres.filter((spacialCharacter)=>spacialCharacter===character);
      if (existSpecialCharacter.length > 0) {
        cleanStringArray[index] = remplaceWith;
      } else {
        cleanStringArray[index] = character;
      }
    });
    const cleanString = cleanStringArray.join("");
    return cleanString;
  };